import { createElementVNode as _createElementVNode, vShow as _vShow, withModifiers as _withModifiers, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../../assets/images/enroll-popup-close-btn.png'


const _withScopeId = n => (_pushScopeId("data-v-4e45bac0"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "mask" }, null, -1))
const _hoisted_2 = { class: "popup-box" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "content" }, " 红包已发送至您的账户，可在APP“我的-钱包”进行提现，稍后金牌顾问会跟您沟通购车意向。 ", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_5 = [
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: "tm-receive-success-popup",
    onTouchmove: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
  }, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: "know-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleWidthDrawal && _ctx.handleWidthDrawal(...args)))
      }, " 立即提现 "),
      _createElementVNode("div", {
        class: "close-btn",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.toggleTmReceiveSuccessPopup(false)))
      }, _hoisted_5)
    ])
  ], 544)), [
    [_vShow, _ctx.isShowTmReceiveSuccessPopup]
  ])
}